import { render, staticRenderFns } from "./EvolutionaryStage.vue?vue&type=template&id=6cdc8df3&functional=true"
import script from "./EvolutionaryStage.vue?vue&type=script&lang=js"
export * from "./EvolutionaryStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports